import { CloseOutlined } from '@ant-design/icons';
import { Drawer, Input } from 'antd';
import { colors } from 'common/colors';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

interface IProps {
  teams: any;
  showSelector: boolean;
  onClose: () => void;
  onSelect: (team: any) => void;
}

const MenuItem = styled.div`
  font-size: 18px;
  font-weight: bold;
  padding: 10px 0px;
  border-radius: 8px;

  &:hover {
    background: ${colors.secondaryGray};
    color: ${colors.mainBlack};
    padding-left: 10px;
  }
`;

const Search = styled(Input)`
  &&& {
    border: none;
    color: white;
    background: ${colors.mainBlack};
    font-size: 16px;
    box-shadow: none;

    &:hover {
      border: none;
    }
  }
`;


export default ({
  teams,
  showSelector = false,
  onClose,
  onSelect,
}: IProps) => {
  const [searchText, setSearchText] = useState('');

  const filteredTeams = useMemo(() => {
    const filtered = teams.filter((team: any) => 
      team.name.toLowerCase().includes(searchText.toLowerCase())
    );
    return filtered;
  }, [teams, searchText]);

  return (
    <Drawer
      closeIcon={<CloseOutlined style={{color: 'white'}} />}
      visible={showSelector}
      headerStyle={{
        backgroundColor: colors.mainBlack,
        color: 'white',
      }}
      bodyStyle={{
        backgroundColor: colors.mainGray,
        color: 'white',
      }}
      title={
        <Search
          placeholder="Type team name..."
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
        />
      }
      placement="bottom"
      onClose={onClose}
      width="100%"
    >
      {
        filteredTeams.map((team: any) => {
          return (
            <MenuItem onClick={() => onSelect(team)}>{team.name}</MenuItem>
          )
        })
      }
    </Drawer>
  )
};
